<script lang="ts">
type Props = {
  primaryText: string;
};
</script>

<script setup lang="ts">
const props = defineProps<Props>();

const [primaryFirstLine, ...primarySecondLine] = props.primaryText.split('\n');
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.primaryText">{{ primaryFirstLine }}</div>
    <div v-if="primarySecondLine" :class="$style.secondaryText">
      {{ primarySecondLine.join('\n') }}
    </div>
  </div>
</template>

<style module lang="scss" src="./Copyright.scss" />
